import { Helmet } from 'react-helmet';
import '../assets/styles/OurTeam.css';

function OurTeam() {
  return (
    <>
      <Helmet>
        <title>RFF Cargo: Board of Directors</title>
        <meta name="description" content="Meet the esteemed Board of Directors at RFF Cargo, leading our global logistics excellence." />
      </Helmet>
      <section className="our-team-section py-5">
        <div className="container">
          <h2 className="team-title fw-bold mb-4">Board of Directors</h2>
          <p className="team-description">
            Our board of directors brings extensive expertise to drive RFF Cargo’s mission of seamless global logistics.
          </p>
          <div className="row">
            {/* Board Member 1 */}
            <div className="col-md-3 mb-4">
              <div className="card board-card">
                <div className="card-inner">
                  <div className="card-front">
                    <img
                      src="/assets/images/team_1-1.jpg"
                      className="card-img-top"
                      alt="Aawarsame Warsame, Chairman"
                    />
                    <div className="card-body p-3">
                      <h3 className="card-title">Aawarsame Warsame</h3>
                      <p className="card-text">Chairman</p>
                      <p className="card-text">
                        <a href="mailto:aawarsame@rffcargo.co.ke" aria-label="Email Aawarsame Warsame">
                          aawarsame@rffcargo.co.ke
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className="card-back">
                    <div className="card-body p-3">
                      <h3 className="card-title">Aawarsame Warsame</h3>
                      <p className="board-about">
                        Visionary leader with 20+ years in logistics, guiding RFF Cargo’s strategic growth.
                      </p>
                      <div className="board-social">
                        <a href="#" className="social-icon" aria-label="Aawarsame Warsame LinkedIn">
                          <i className="bi bi-linkedin"></i>
                        </a>
                        <a href="#" className="social-icon" aria-label="Aawarsame Warsame Twitter">
                          <i className="bi bi-twitter"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Board Member 2 */}
            <div className="col-md-3 mb-4">
              <div className="card board-card">
                <div className="card-inner">
                  <div className="card-front">
                    <img
                      src="/assets/images/team_2-1.jpg"
                      className="card-img-top"
                      alt="Yacube Bashir, CEO"
                    />
                    <div className="card-body p-3">
                      <h3 className="card-title">Yacube Bashir</h3>
                      <p className="card-text">Chief Executive Officer</p>
                      <p className="card-text">
                        <a href="mailto:yacubebashir@rffcargo.co.ke" aria-label="Email Yacube Bashir">
                          yacubebashir@rffcargo.co.ke
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className="card-back">
                    <div className="card-body p-3">
                      <h3 className="card-title">Yacube Bashir</h3>
                      <p className="board-about">
                        Dynamic CEO with a focus on operational excellence and global expansion.
                      </p>
                      <div className="board-social">
                        <a href="#" className="social-icon" aria-label="Yacube Bashir LinkedIn">
                          <i className="bi bi-linkedin"></i>
                        </a>
                        <a href="#" className="social-icon" aria-label="Yacube Bashir Twitter">
                          <i className="bi bi-twitter"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Board Member 3 */}
            <div className="col-md-3 mb-4">
              <div className="card board-card">
                <div className="card-inner">
                  <div className="card-front">
                    <img
                      src="/assets/images/team_3-1.jpg"
                      className="card-img-top"
                      alt="Mhareed Hassan, CFO"
                    />
                    <div className="card-body p-3">
                      <h3 className="card-title">Mhareed Hassan</h3>
                      <p className="card-text">Chief Financial Officer</p>
                      <p className="card-text">
                        <a href="mailto:mhareed@rffcargo.co.ke" aria-label="Email Mhareed Hassan">
                          mhareed@rffcargo.co.ke
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className="card-back">
                    <div className="card-body p-3">
                      <h3 className="card-title">Mhareed Hassan</h3>
                      <p className="board-about">
                        Financial strategist ensuring RFF Cargo’s fiscal health and growth.
                      </p>
                      <div className="board-social">
                        <a href="#" className="social-icon" aria-label="Mhareed Hassan LinkedIn">
                          <i className="bi bi-linkedin"></i>
                        </a>
                        <a href="#" className="social-icon" aria-label="Mhareed Hassan Twitter">
                          <i className="bi bi-twitter"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Board Member 4 */}
            <div className="col-md-3 mb-4">
              <div className="card board-card">
                <div className="card-inner">
                  <div className="card-front">
                    <img
                      src="/assets/images/team_4-1.jpg"
                      className="card-img-top"
                      alt="Keita Hussein, Director of Operations"
                    />
                    <div className="card-body p-3">
                      <h3 className="card-title">Keita Hussein</h3>
                      <p className="card-text">Director of Operations</p>
                      <p className="card-text">
                        <a href="mailto:keitahussein@rffcargo.co.ke" aria-label="Email Keita Hussein">
                          keitahussein@rffcargo.co.ke
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className="card-back">
                    <div className="card-body p-3">
                      <h3 className="card-title">Keita Hussein</h3>
                      <p className="board-about">
                        Operations expert optimizing RFF Cargo’s global logistics network.
                      </p>
                      <div className="board-social">
                        <a href="#" className="social-icon" aria-label="Keita Hussein LinkedIn">
                          <i className="bi bi-linkedin"></i>
                        </a>
                        <a href="#" className="social-icon" aria-label="Keita Hussein Twitter">
                          <i className="bi bi-twitter"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default OurTeam;